<template>
  <validation-provider
    #default="{ errors }"
    name="Üye"
    rules="required"
  >
    <v-select
      v-model="dataItem[iKey].id_member_users"
      :options="filteredDataList"
      label="name"
      :reduce="item => item.id"
      placeholder="Üye"
    >
      <template v-slot:option="option">
        {{ option.name }}
        <div v-if="option.user_types">
          <b-badge variant="light-primary">
            <feather-icon icon="StarIcon" />
            {{ option.user_types }}
          </b-badge>
        </div>
      </template>
      <template v-slot:selected-option="option">
        {{ option.name }}
        <b-badge
          v-if="option.user_types"
          variant="light-primary"
          class="ml-1"
        >
          <feather-icon icon="StarIcon" />
          {{ option.user_types }}
        </b-badge>
      </template>
    </v-select>
    <small class="text-danger">{{ errors[0] }}</small>
  </validation-provider>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BBadge,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'MemberUsersSelectCard',
  components: {
    vSelect,
    ValidationProvider,
    BBadge,
  },
  props: {
    iKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['users/dataList']
    },
    dataItem() {
      return this.$store.getters['teamMembers/dataList']
    },
    currentRow() {
      return this.dataItem[this.iKey] || {}
    },
    currentSelection() {
      return this.currentRow.id_member_users || null
    },
    selectedUserIds() {
      return this.dataItem
        .map(item => item && item.id_member_users)
        .filter(id => id !== null && id !== undefined)
    },
    filteredDataList() {
      if (!Array.isArray(this.dataList)) return []

      const takenIds = new Set(this.selectedUserIds.filter(id => id !== this.currentSelection))

      return this.dataList.filter(option => !takenIds.has(option.id) || option.id === this.currentSelection)
    },
  },
  created() {
    localize('tr')
  },
  methods: {

  },
}
</script>
